export default __webpack_public_path__ + "static/seoFoursource-89e92b3d75e5e0674b8b57f654e23d49.png";